import { Injectable } from '@angular/core';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { Platform } from '@ionic/angular';

@Injectable()
export class TemporaryStorageService {
  constructor(
    private _nativeStorage: NativeStorage,
    private _platform: Platform,
  ) {}

  /**
   *
   *
   * @param {string} settingId
   * @param {*} value
   * @returns
   * @memberof NativeStorageService
   */
  set(settingId: string, value: any) {
    return window.sessionStorage.setItem(`storage:${settingId}`, value);
  }

  /**
   *
   *
   * @param {string} settingId
   * @returns
   * @memberof NativeStorageService
   */
  get(settingId: string) {
    return window.sessionStorage.getItem(`storage:${settingId}`);
  }

  /**
   *
   *
   * @param {string} settingId
   * @returns
   * @memberof NativeStorageService
   */
  remove(settingId: string) {
    return window.sessionStorage.removeItem(`storage:${settingId}`);
  }

  /**
   *
   *
   * @memberof NativeStorageService
   */
  clear() {
    return window.sessionStorage.clear();
  }
}
